export default "__VITE_ASSET__e48cea29__"